import type { StringUnion } from '@gonfalon/types/StringUnion';

export const FALLTHROUGH_RULE_ID = 'fallthrough';

export type AutomatedRolloutConfigurationKey = StringUnion<typeof FALLTHROUGH_RULE_ID>;
